// @flow

import _ from 'lodash';

// Application infrastructure
import {withDependencies} from './utils/with-dependencies';
import {SERVICES} from './constants';

import type {Route, Router} from './routing';
import type {IDependencyResolver} from './annotation/di';


/*
 * Provides routing and dependency injection for applications.
 */
@withDependencies({
	services: [SERVICES.RESOLVER, SERVICES.ROUTER],
})
export class Application {

	_resolver: IDependencyResolver;
	_router: Router; // Url-hash based router

	constructor (
		resolver: IDependencyResolver,
		router: Router,
	) {
		this._router = router;
		this._resolver = resolver;
	}

	startRouter (...args: [string]): Application {
		if (!_.isEmpty(args)) {
			this._router.setUrl(...args);
		}

		this._router.run();

		return this;
	}

	/*
	 * Starts the app: Creates the entry point of app (if {mainModule} is passed)
	 */
	startApp (mainModuleName?: string): Application {

		// Instantiate the main module
		if (mainModuleName) {
			this._resolver.get(mainModuleName);
		}

		return this;
	}

	/*
	 * Registers controller's routes for the app.
	 */
	registerRoutes (routes: Route[]): void {
		routes.forEach(route => {
			this._router.registerRoute(route);
		});
	}
}
